import React from "react";
import { useTranslation } from "react-i18next";

import FuelReportsTab from "./tabs/FuelReports";
import Tabs from "components/shared/Tabs";

const InventoryReports = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const inventoryReportsTabs = React.useMemo(() => {
    const fuelReportsTab = <FuelReportsTab />;

    return [
      {
        label: t("inventoryReport.fuelAnalysis"),
        content: fuelReportsTab,
      },
    ];
  }, []);

  return (
    <React.Fragment>
      <Tabs tabs={inventoryReportsTabs} tabValue={tabValue} onTabChange={handleTabChange} isVertical={false} />
    </React.Fragment>
  );
};

export default InventoryReports;
